// extracted by mini-css-extract-plugin
export var copyableField = "_mv-4";
export var customerBadge = "_mv-0";
export var customerInfoTitle = "_mv-2";
export var details = "_mv-1";
export var dropdownContainer = "_mv-5";
export var dropdownImage = "_mv-6";
export var editAssigneeForm = "_mv-a";
export var editButton = "_mv-3";
export var email = "_mv-7";
export var hidden = "_mv-d";
export var input = "_mv-8";
export var saveButton = "_mv-b";
export var shopifyIcon = "_mv-c";
export var suggestionBadge = "_mv-e";
export var suggestionText = "_mv-f";
export var username = "_mv-9";